import React from "react";
import { useAuth } from "../../../../../context/AuthContext";
import { OfflineLabtestListing } from "./OfflineLabtestListing";

export const OfflineLabtestOrderPage: React.FC = () => {
  const { user } = useAuth();
  const clinicId = user?.role === "clinic" ? user?.id : "";

  return (
    <div className="p-4 w-full h-[calc(100vh-100px)]">
      <OfflineLabtestListing clinicId={clinicId || ""} />
    </div>
  );
};

export default OfflineLabtestOrderPage;
